<template>
  <b-dropdown
    ref="dropdown"
    variant="transparent-lightBlue" 
    :toggle-class="{
      'btn-square': true,
      'active': active,
    }"
    menu-class="p-0 clear-min-width"
    no-caret
    :dropup="dropup"
  >
    <template #button-content>
      <div
        :id="id"
        :title="title"
        v-b-tooltip.manual
        @mouseover="mouseover"
        @mouseleave="mouseleave"
      >
        <slot name="button-content"></slot>
      </div>
    </template>

    <slot></slot>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    active: {
      default: undefined,
    },
    title: {
      default: undefined,
    },
    dropup: {
      default: undefined,
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
    }),
    id() {
      return this.title ? `texteditor-tool-${this.title.replaceAll(' ', '')}` : this.title;
    },
  },methods: {
    mouseover() {
      if (this.id) this.$root.$emit('bv::show::tooltip', this.id)
    },
    mouseleave() {
      if (this.id) this.$root.$emit('bv::hide::tooltip', this.id)
    },
  },
}
</script>
